import angular from 'angular'
import addLoanPartListingModule from './addLoanPartListing/addLoanPartListing'
import showLoanPartListingsModule from './showLoanPartListings/showLoanPartListings'

import manageLoanPartListingsComponent from './manageLoanPartListings.component'

export default angular.module('app.common.loanParts.loanPartDetails.manageLoanPartListings', [addLoanPartListingModule.name, showLoanPartListingsModule.name])
  .directive('manageLoanPartListings', manageLoanPartListingsComponent)
